<div class="hero-bg hero-bg-culture">
  <app-navbar/>
  <div class="d-flex flex-column justify-content-center hero-header">
    <div class="app-container">
      <h1 class="new-line">{{ 'Login' | translate }}</h1>
    </div>
  </div>
</div>
<div class="login-form-container app-container pt-4">
  <div class="login-form">
    <label>Email:</label>
    <div class="form-group" label='Email'>
      <input class="form-control" [(ngModel)]="model.userName"
             [disabled]="this.saving"
             autocomplete="username"
             placeholder="Email"/>
    </div>
    <div class="mt-2"></div>
    <label>Password:</label>
    <div class="form-group" label='Password'>
      <input class="form-control" [(ngModel)]="model.password"
             type="password"
             autocomplete="current-password"
             [disabled]="this.saving"
             placeholder="Password"/>
    </div>
    <div class="mt-2 d-flex">
      <button class="btn btn-primary"
              type="submit"
              [disabled]="this.saving"
              (click)="login()"
              style='margin-right: 10px'>
        Login
      </button>

    </div>
  </div>
</div>
